import React from "react";
import {
  Box,
  Text,
  Button,
  useColorModeValue,
  useToast,
  HStack,
  Link,
  Flex,
} from "@chakra-ui/react";
import {
  CopyIcon,
  EmailIcon,
  CalendarIcon,
  ExternalLinkIcon,
} from "@chakra-ui/icons";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { HOST, getBid } from "../../lib/Auth";
import GenericSettings from "./GenericSettings";

const DisplayInfo = () => {
  const toast = useToast();
  const bgColor = useColorModeValue("gray.100", "gray.700");
  
  const H = HOST.split('://')[1]
  const ENV = H.startsWith("qa-")
    ? "qa"
    : H.startsWith("api")
    ? "prod"
    : "dev";

  const configuration = [
    {
      title: "Business Profile",
      description: "",
      inputs: [
        {
          type: "input",
          name: "Business Name",
          pattern: /[^\ ]{3,}/,
          id: "name",
        },
        {
          type : "select",
          name : 'Time Zone',
          id : 'zone',
          options : [{
            label : 'Eastern Time Zone (ET)',
            value : 'America/New_York'
          },{
            label : 'Central Time Zone (CT)',
            value : 'America/Chicago'
          },{
            label : 'Mountain Time Zone (MT)',
            value : 'America/Denver'
          },{
            label : 'Pacific Time Zone (PT)',
            value : 'America/Los_Angeles'
          },{
            label : 'Arizona',
            value : 'America/Phoenix'
          },{
            label : 'Indianapolis',
            value : 'America/Indiana/Indianapolis'
          }]
        },{
          type: "input",
          id: "website",
          pattern: /^(|https?\:\/\/[^\.]{1,}(\.[^\.]{1,})*\.[^\.]{2,})$/,
        }
      ],
    },
  ];

  const mailDomain = {
    qa: "qa-inbox.getviva.ai",
    prod: "inbox.getviva.ai",
    dev: "dev-inbox.getviva.ai",
  }[ENV];

  const handleCopy = (text) => {
    toast({
      title: "Copied to clipboard",
      description: `${text} has been copied to your clipboard.`,
      status: "success",
      duration: 2000,
      isClosable: true,
    });
  };

  const scriptSnippet = `<script src="${HOST}/widget.js?bid=${getBid()}" async></script>`;
  const emailAddress = `${getBid()}@${mailDomain}`;
  const calendarLink = `${location.protocol}//${location.hostname.replace(
    "app",
    "booking"
  )}/?bid=${getBid()}`;

  return (
    <Box p={4} overflowY="auto" maxH="100vh" w="100%" align="left">
      <GenericSettings
        configuration={configuration}
        endpoint={"/settings/business"}
        method={"put"}
      />
      <Box p={4} overflowY="auto" maxH="100vh" w="100%" align="left">
        <Box mb={4} p={4} bgColor={bgColor} borderRadius="md">
          <Text fontSize="lg" mb={2}>
            Office Email Address
          </Text>
          <HStack>
            <Text>{emailAddress}</Text>
            <CopyToClipboard
              text={emailAddress}
              onCopy={() => handleCopy("Email address")}
            >
              <Button leftIcon={<EmailIcon />} colorScheme="blue" size="sm">
                Copy to Clipboard
              </Button>
            </CopyToClipboard>
          </HStack>
        </Box>
        <Box mb={4} p={4} bgColor={bgColor} borderRadius="md">
          <Flex>
            <Text fontSize="lg" mb={2}>
              Online Booking Link
            </Text>
            <Link href={calendarLink} target="_blank">
              <ExternalLinkIcon ml="2" />
            </Link>
          </Flex>

          <HStack>
            <Text>{calendarLink}</Text>
            <CopyToClipboard
              text={calendarLink}
              onCopy={() => handleCopy("Calendar Link")}
            >
              <Button leftIcon={<CalendarIcon />} colorScheme="blue" size="sm">
                Copy to Clipboard
              </Button>
            </CopyToClipboard>
          </HStack>
        </Box>
        <Box mb={4} p={4} bgColor={bgColor} borderRadius="md">
          <Text fontSize="lg" mb={2}>
            Script Snippet
          </Text>
          <HStack>
            <Box
              p={2}
              bgColor="gray.800"
              color="white"
              borderRadius="md"
              fontFamily="monospace"
              flex="1"
            >
              {scriptSnippet}
            </Box>
            <CopyToClipboard
              text={scriptSnippet}
              onCopy={() => handleCopy("Script snippet")}
            >
              <Button leftIcon={<CopyIcon />} colorScheme="blue" size="sm">
                Copy to Clipboard
              </Button>
            </CopyToClipboard>
          </HStack>
        </Box>
      </Box>
    </Box>
  );
};

export default DisplayInfo;
